import * as TableGenericModule from './_components/TableGeneric.vue';
// Vue 2 SFC TS shim (`*.vue`) usually exposes only `default`, but this file also exports
// a typed factory `GenericTable<T>()`. We re-export it via a module-namespace import.
export const GenericTable = TableGenericModule.GenericTable;
export var TableStyle;
(function (TableStyle) {
    TableStyle["Resources"] = "resources";
    TableStyle["Flat"] = "flat";
    TableStyle["List"] = "list";
})(TableStyle || (TableStyle = {}));
